import lightGreen from "@material-ui/core/colors/lightGreen";
import red from "@material-ui/core/colors/red";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { subMonths } from "date-fns";
import * as React from "react";
import { connect } from "react-redux";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Label,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { StoreState } from "../store";
import { Score } from "../types/index";
import { format, numberFormat } from "../utilities";
import ProgressOverlay from "./ProgressOverlay";

function mapStateToProps({ cluster, dashboardFilter }: StoreState) {
  return {
    cluster,
    dashboardFilter,
  };
}

type Props = ReturnType<typeof mapStateToProps>;

const CLV_COLORS = [lightGreen[100], lightGreen[500], lightGreen[900]];
const CHRUN_COLORS = [red[100], red[300], red[800]];

class StackedBarChart extends React.Component<Props & StyledComponentProps> {
  public render() {
    const { classes, dashboardFilter } = this.props;
    const colors =
      this.props.dashboardFilter.score === Score.CLV
        ? CLV_COLORS
        : CHRUN_COLORS;
    const labelAndAxisColor = "#666666";
    const scoreLabel =
      dashboardFilter.score === Score.CHURN ? "Churn Score" : "CLV";
    const startDateLabel = format(
      subMonths(new Date(), dashboardFilter.dateRange),
      "MMMM yyyy"
    );
    const endDateLabel = format(new Date(), "MMMM yyyy");

    return (
      <Paper className={classes && classes.paper}>
        <ProgressOverlay loading={this.props.cluster.loading}>
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
              <Typography variant="h6">
                Verteilung {scoreLabel} für {startDateLabel} bis {endDateLabel}
              </Typography>
            </Grid>
            <Grid item={true} xs={12}>
              <Typography component="div">
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={this.getData()}>
                    <CartesianGrid />
                    <XAxis dataKey="date" stroke={labelAndAxisColor} />
                    <YAxis
                      stroke={labelAndAxisColor}
                      tickFormatter={numberFormat as any}
                    >
                      <Label
                        angle={-90}
                        fill={labelAndAxisColor}
                        value="Anzahl Kunden"
                        position="insideLeft"
                        style={{ textAnchor: "middle" }}
                        width={200}
                      />
                    </YAxis>
                    <Tooltip
                      formatter={(v: any) => numberFormat(Number(v), false)}
                    />
                    <Legend />
                    <Bar dataKey="gering" stackId="a" fill={colors[0]} />
                    <Bar dataKey="mittel" stackId="a" fill={colors[1]} />
                    <Bar dataKey="hoch" stackId="a" fill={colors[2]} />
                  </BarChart>
                </ResponsiveContainer>
              </Typography>
            </Grid>
          </Grid>
        </ProgressOverlay>
      </Paper>
    );
  }

  private getData = () => {
    return this.props.cluster.data.map((d) => ({
      ...d,
      date: new Date(d.date).toLocaleDateString(),
      gering: d.min,
      hoch: d.max,
      mittel: d.mid,
    }));
  };
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
});

export default connect(mapStateToProps)(withStyles(styles)(StackedBarChart));



// WEBPACK FOOTER //
// ./src/components/StackedBarChart.tsx